<template lang="html">
  <Row type="flex" style="padding: 10vh 5vw;" id="getting-started" justify="space-around" align="middle">
    <Col style="width: 420px" class="item">
      <Row type="flex" justify="center" style="text-align: center;">
        <h1 style="padding-bottom: 8px; font-size: 2rem;">Schedule a Demo!</h1>
        <h2 style="padding-bottom: 16px;">Schedule a time with our team to learn more about Vue Finance and how we help you <strong>be more effective financially</strong>.</h2>
        <ScheduleButton title="Schedule a Demo" eventType="demo" :isMobile="isMobile"></ScheduleButton>
        <GetStartedButton style="margin-left: 4px" type="ghost" title="Get Started" :arrow="true"></GetStartedButton>
      </Row>
    </Col>
    <Col class="item">
      <img src="/static/dashboard.png" :style="{ 'max-width': isMobile ? '100%' : '550px' }">
    </Col>
  </Row>
</template>

<script>
import GetStartedButton from './GetStartedButton';
import ScheduleButton from './ScheduleButton';

export default {
  props: ['isMobile'],
  components: { GetStartedButton, ScheduleButton },
};
</script>

<style lang="css" scoped>
.item {
  padding-top: 28px;
  padding-bottom: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduleDemo.vue